import { render, staticRenderFns } from "./Visit-trips.vue?vue&type=template&id=1ec517fb"
import script from "./Visit-trips.vue?vue&type=script&lang=js"
export * from "./Visit-trips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports